// frontend\src\constants.js
export const APP_NAME = "Фотохимия";
export const APP_VERSION = process.env.REACT_APP_VERSION || "0.0.0.0";

export const GET_REGISTER_API = `/register/`;
export const GET_TOKEN_API = `/token/`;
export const GET_FILMS_API = `/films/`;
export const GET_DEVELOPERS_API = `/developers/`;
export const GET_PROCESS_API = `/process/`;
export const SCANS_API = "/scans/";
export const FILMS_API = "/materials/films/";
export const CHEMICALS_API = "/materials/chemicals/";
export const CHEMICAL_TYPES_API = "/materials/chemical-types/";
export const CHEMICAL_USAGE_API = "/materials/chemical-usage/";